const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/config/com/eCheckin/sections/PatientInfo.tsx';
import * as React from 'react';
import { forwardRef } from 'react';
import { useCIS4m } from '@cistec/common_web/modules/CIS4m/hooks';
import { useIntl } from 'react-intl';
import textMap from '../translations';
import { ECheckinSectionProps } from 'App/components/eCheckin/types';
import ECheckinSection from 'App/components/eCheckin/components/ECheckinSection';
import Divider from '@mui/material/Divider';
import { Link, LinksBlock } from 'App/components/eCheckin/components/fields/LinksBlock';
import { useText } from '@cistec/common_web/utils/intlUtils';

const links: Link[] = [
    {
        name: 'checkliste',
        text: textMap.checkliste,
        href: 'https://www.bag.admin.ch/bag/de/home/medizin-und-forschung/patientenrechte.html',
    },
];

export const PatientInfo = forwardRef((props: ECheckinSectionProps, ref: any) => {
    const { path } = props;
    const title = useText(props.title);

    const { formatMessage } = useIntl();

    const eCheckinSectionRef = useCIS4m(ref);

    return (
        <ECheckinSection ref={eCheckinSectionRef} path={path} title={title}>
            <h1>{title}</h1>
            <p>{formatMessage(textMap.pleaseReadAndConfirm)}</p>
            <Divider />
            <LinksBlock links={links} basePath={props.path} />
        </ECheckinSection>
    );
});

PatientInfo.displayName = 'PatientInfo';

export default PatientInfo;
